import { Link } from 'react-router-dom';
import {
  AgxHeader,
  Images,
  AgxDiagonalUpArrowIcon,
  formatCurrency,
} from '@urbanx/agx-ui-components';
import { StaffBasicMarketingPackageModel } from '@urbanx/agx.marketing.client';
import { Pages } from 'constants/menu';
import './MarketingPackage.scss';
import CampaignFlowStatusBadge from './CampaignFlowStatusBadge';
import { AgxColumn, AgxRow, AgxTypography } from '@urbanx/agx.ui-components2';
import { AgencyDetailsModel } from '@urbanx/agx.agencies.client';
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client';

interface MarketingPackageProps {
  marketingPackages: StaffBasicMarketingPackageModel[];
  marketingPackagesIsPending: boolean;
  agency?: AgencyDetailsModel;
  campaign?: CampaignDetailModel;
}

const MarketingPackage = ({
  marketingPackages,
  marketingPackagesIsPending,
  agency,
  campaign,
}: MarketingPackageProps) => {
  return (
    <>
      {marketingPackagesIsPending && <AgxRow padding={{ top: 'spacing-lg' }}>Loading...</AgxRow>}
      {!marketingPackagesIsPending && !(marketingPackages?.length ?? 0) && (
        <AgxRow padding={{ top: 'spacing-lg' }}>No marketing packages found for campaign</AgxRow>
      )}
      {!marketingPackagesIsPending && (marketingPackages?.length ?? 0) > 0 && (
        <AgxColumn id="campaignMarketing" gap="spacing-2xl" fill>
          <table className="campaignMarketingTable">
            <tbody>
              <tr>
                <th align="left" className="column-name">
                  <AgxTypography type="body" size="small" id="marketing">
                    Marketing
                  </AgxTypography>
                </th>
                <th align="left" className="column-name">
                  <AgxTypography type="body" size="small" id="flowNo">
                    Flow no.
                  </AgxTypography>
                </th>
                <th align="left" className="column-name">
                  <AgxTypography type="body" size="small" id="status">
                    Status
                  </AgxTypography>
                </th>
                <th align="left" className="column-name">
                  <AgxTypography type="body" size="small" id="totalMarketing">
                    Total marketing
                  </AgxTypography>
                </th>
                <th align="left" className="column-name">
                  <AgxTypography type="body" size="small" id="vendorToPay">
                    Vendor to pay
                  </AgxTypography>
                </th>
              </tr>
              {marketingPackages &&
                marketingPackages.map((marketingPackage) => (
                  <tr
                    key={`marketing-row-${marketingPackage.marketingPackageId}`}
                    className="marketingStatusRow"
                  >
                    <td>
                      <AgxRow gap="spacing-md" alignItems="alignCenter">
                        <Images.SparkleSmall />
                        <Link
                          className="marketingPackageRowLink"
                          to={`/${Pages.AGENCIES}/${agency?.id}/campaigns/${campaign?.campaignId}/campaign-marketing/${marketingPackage.marketingPackageId}`}
                        >
                          <AgxHeader size={4}>{marketingPackage.packageTemplateName}</AgxHeader>
                        </Link>
                      </AgxRow>
                    </td>
                    <td>
                      <AgxRow gap="spacing-md" alignItems="alignCenter">
                        <a
                          href={marketingPackage.campaignFlowCampaignUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="campaignIdLink"
                        >
                          <AgxTypography type="body" size="small" id="campaignIdLink">
                            {marketingPackage.campaignFlowCampaignId}
                          </AgxTypography>
                          <AgxDiagonalUpArrowIcon color="#318CE0" width={16} height={16} />
                        </a>
                      </AgxRow>
                    </td>
                    <td>
                      <AgxColumn fill gap="spacing-xs">
                        <CampaignFlowStatusBadge
                          status={marketingPackage.campaignFlowDisplayStatus}
                        />
                        {marketingPackage.campaignFlowStatusInfo && (
                          <AgxTypography type="body" size="small" id="campaignFlowStatusInfo">
                            {marketingPackage.campaignFlowStatusInfo}
                          </AgxTypography>
                        )}
                      </AgxColumn>
                    </td>
                    <td>
                      <AgxTypography type="body" size="small" id="campaignMarketingAmountTotal">
                        {formatCurrency(marketingPackage.total || null, 2)}
                      </AgxTypography>
                    </td>
                    <td>
                      <AgxTypography
                        type="body"
                        size="small"
                        id="campaignMarketingAmountVendorToPay"
                      >
                        {formatCurrency(marketingPackage?.amountVendorToPay || null, 2)}
                      </AgxTypography>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </AgxColumn>
      )}
    </>
  );
};

export default MarketingPackage;
